<div *ngIf="isMobile; else webLogin" class="full-container">

  <div class="fixed-rate-container-mobile">
    <div class="top-content">
      <div class="bid-card-mobile">
        <div class="bid-details-and-edit">
        </div>
        <div class="bid-info-mobile">
          <div class="bid-first-column-mobile">
            <div class="top-label-mobile">
              From Date <br> <span>{{ formatTradeTimeYear(ownBid.trade_start) }}</span>
            </div>
            <div class="bid-values-mobile">
              Partner Name <br> <span>{{partnerBid.user_name}}</span>
            </div>
          </div>
          <div class="bid-second-column-mobile">
            <div class="top-label-mobile">
              To Date <br> <span>{{ formatTradeTimeYear(ownBid.trade_end) }}</span>
            </div>
            <div class="bid-values-mobile">
              Partner ID <br> <span>{{partnerBid.customer_id}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="middle-content">
        <div class="bid-note-mobile">
          Note: <br> This bid is open <br> From {{formatBidTime(ownBid.bid_start)}} <br> To {{formatBidTime(ownBid.bid_end)}}
        </div>
        <div class="bid-offer-mobile" *ngIf="isActiveSession()">
          <div class="first-divider-mobile"></div>
          <div class="bid-decision-mobile"><span class="bid-type-offer-mobile">{{ownBid.transaction_type}} Offer</span>
            <span><span class="bid-offer-values-mobile">{{ownBid.energy_amount}}</span> Kwh </span> <span>&#64; <span
                class="bid-offer-values-mobile">{{ownBid.bid_price}}</span> Rs.</span>
          </div>
          <div class="second-divider-mobile"></div>
        </div>

        <div *ngIf="isRejected()" class="bid-rejected-mobile">
          <div class="first-divider-mobile"></div>
          <div class="rejected-text-mobile">Bid was rejected</div>
          <div class="second-divider-mobile"></div>
        </div>

        <div *ngIf="canRebid()" class="rebid-and-accept-mobile-buttons">
          <div class="rebid-button-mobile">
            <button (click)="openUpdateBidModal()" type="submit">
              Propose new rate
            </button>
          </div>
          <div class="accept-button-mobile">
            <button (click)="acceptBid()" type="submit" class="accept-button-mobile">Accept</button>
          </div>
        </div>

        <div *ngIf="canUpdate()" class="update-button-mobile">
          <button type="submit" (click)="openUpdateBidModal()">Update Bid</button>
        </div>
      </div>
    </div>

    <div class="bottom-content">
      <div class="withdraw-and-remind-partner-buttons">
        <div class="withdraw-button-mobile">
          <button (click)="withdraw()" type="submit" [disabled]="!isActiveSession()" *ngIf="!receiveOfferWithdraw()">
            Withdraw
          </button>
          <button (click)="withdraw()" type="submit" [disabled]="!isActiveSession()" *ngIf="receiveOfferWithdraw()">
            Reject
          </button>
        </div>
        <div class="remind-partner-button-mobile">
          <button type="submit" (click)="remindPartner()" *ngIf="ownBid.status === 'ACTIVE'"
            [disabled]="!isActiveSession() || !partnerHasProposedNewOffer">Remind Partner</button>
          <button type="submit" (click)="remindPartner()" *ngIf="ownBid.status === 'ACCEPTED'"
            [disabled]="!isActiveSession() || !getUpdatedBidFlagValue()">Remind Partner</button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #webLogin>
  <body>
    <div *ngIf="ownBid && partnerBid" class="container">
      <div class="content">
        <div class="details">
          <div class="column">
            <div class="bid-info">
              <div
                class="bid-type"
                [ngClass]="{
                  'bid-info-sell': getTransactionType() === 'Sell',
                  'bid-info-buy': getTransactionType() === 'Buy'
                }"
              >
                <span>Bid Type</span>: Preferential Exchange of Energy
              </div>

              <div *ngIf="isLoading" class="loading-web">
                {{
                  userBidAction === 'accept'
                    ? 'Accepting your bid, please wait...'
                    : userBidAction === 'reject'
                    ? 'Rejecting your bid, please wait...'
                    : ''
                }}
              </div>

              <div class="message-bid">You already placed the below Bid</div>

              <div class="bid-field-container">
                <div class="field">From Date</div>
                <div class="value">{{ formatTradeTimeYear(ownBid.trade_start) }}</div>
              </div>

              <div class="bid-field-container">
                <div class="field">To Date</div>
                <div class="value">{{ formatTradeTimeYear(ownBid.trade_end) }}</div>
              </div>

              <div class="bid-field-container">
                <div class="field">Partner Customer Name</div>
                <div class="value">{{ partnerBid.user_name }}</div>
              </div>

              <div class="bid-field-container">
                <div class="field">Partner Customer ID</div>
                <div class="value">{{ partnerBid.customer_id }}</div>
              </div>

              <div class="actions">
                <div class="update-container" *ngIf="canUpdate()">
                  <button
                    type="submit"
                    class="update-button"
                    (click)="openUpdateBidModal()"
                    [disabled]="isLoading"
                  >
                    Update Bid
                  </button>
                </div>

                <button
                  *ngIf="canRebid()"
                  [disabled]="isLoading"
                  (click)="openUpdateBidModal()"
                  type="submit"
                  class="edit-button"
                >
                  Propose new rate
                </button>

                <!-- Left-column Remind: active bids -->
                <button
                  class="remind-button"
                  type="submit"
                  (click)="remindPartner()"
                  *ngIf="ownBid.status === 'ACTIVE'"
                  [disabled]="
                    !isActiveSession() ||
                    isLoading ||
                    (
              
                      (!(remindEnabled && !remindUsed) && !partnerHasProposedNewOffer)
                    )
                  "
                  [title]="
                    !isActiveSession()
                      ? 'Cannot remind: session inactive'
                      : isLoading
                      ? 'Please wait...'
                      : (remindEnabled && !remindUsed) || partnerHasProposedNewOffer
                      ? 'Send reminder'
                      : 'Remind disabled until you edit the bid'
                  "
                >
                  Remind Partner
                
                </button>
              </div>
            </div>
          </div>

          <div class="column">
            <div class="fixed-rate-container">
              <div class="fixed-rate-info">
                <div class="notice">Note : This bid is open</div>

                <div class="date-container">
                  <div class="date">From </div>
                  <div class="date">{{ formatBidTime(ownBid.bid_start) }}</div>
                </div>

                <div class="date-container">
                  <div class="date">To </div>
                  <div class="date">{{ formatBidTime(ownBid.bid_end) }}</div>
                </div>

                <div class="separator"></div>

                <div class="bid-offer" *ngIf="isActiveSession()">
                  <div class="offer-type">{{ ownBid.transaction_type }} Offer</div>
                  <div class="offer-info">
                    <div class="number"> {{ ownBid.energy_amount }} </div>
                    <div class="unit"> kWh </div>
                    <div class="number"> {{ ownBid.strike_price }} </div>
                    <div class="unit"> Rs. </div>
                  </div>
                  <div class="separator"></div>
                </div>

                <div *ngIf="isRejected()" class="strike">
                  <div class="instructions">Bid was rejected</div>
                </div>

                <div class="message-bid-right" *ngIf="isPartner">
                  You can Accept or Reject the price
                </div>
              </div>

              <div class="actions" *ngIf="isPartner">
                <button
                  (click)="withdraw()"
                  type="submit"
                  [disabled]="!isActiveSession() || isLoading"
                  class="reject-button"
                >
                  Reject
                </button>

                <button
                  (click)="acceptBid()"
                  type="submit"
                  class="accept-button"
                  [disabled]="isLoading"
                >
                  Accept
                </button>
              </div>

              <div class="actions" *ngIf="!isPartner">
                <button
                  (click)="withdraw()"
                  type="submit"
                  [disabled]="!isActiveSession() || isLoading"
                  class="reject-button"
                >
                  Withdraw bid
                </button>

              
                <button
                  class="remind-button"
                  type="submit"
                  (click)="remindPartner()"
                  *ngIf="ownBid.status === 'ACCEPTED'"
                  [disabled]="
                    !isActiveSession() ||
                    isLoading ||
                    !(remindEnabled && !remindUsed)
                  "
                  [title]="
                    !isActiveSession()
                      ? 'Cannot remind: session inactive'
                      : isLoading
                      ? 'Please wait...'
                      : (remindEnabled && !remindUsed)
                      ? 'Send one-time reminder'
                      : 'Remind disabled until you edit the bid'
                  "
                >
                  Remind Partner
               
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>
</ng-template>
